import { useTranslation } from "react-i18next";
import MemberVouchers, {
  VoucherDisplayType,
} from "@/features/Common/components/MemberVouchers";
import useGetMemberDiscountVouchers from "../../pages/MyDiscountVouchersPage/hooks/useGetMyDiscountVouchers";
import useApplyDiscountVoucher from "./hooks";

export default function MyDiscountVouchers() {
  const { t } = useTranslation();

  const {
    memberDiscountVouchers,
    isMemberDiscountVouchersLoading,
    memberDiscountVouchersFetchError,
  } = useGetMemberDiscountVouchers();

  const { applyVoucher, isLoading, error, isError, resetError } =
    useApplyDiscountVoucher();

  return (
    <MemberVouchers
      voucherDisplayType={VoucherDisplayType.DiscountVoucher}
      title={t("More.myDiscountVouchers.title")}
      memberVoucherItems={memberDiscountVouchers}
      isMemberVouchersLoading={isMemberDiscountVouchersLoading}
      memberVouchersFetchError={memberDiscountVouchersFetchError}
      backNavigationPath="/home/more"
      applyDiscountVoucher={applyVoucher}
      isLoading={isLoading}
      error={error}
      isError={isError}
      resetError={resetError}
    />
  );
}
